export enum OrderStatus {
  WAITING_FOR_CONFIRMATION = 1,
  CONFIRMED = 2,
  PREPARING = 3,
  COMPLETED = 4,
  MORE_ITEMS_ADDED = 5,
  CANCELLED = 6,
  DELETE = 9,
  SCHEDULED_ORDER = 11
}

export enum GiveRefunds {
  CASH = 'cash',
  ONLINE = 'online',
  OFFLINE = 'offline'
}

export enum ModalStatus {
  SUCCESS = 'success',
  CLOSE = 'close'
}
export enum OrderTabs {
  RUNNING_ORDERS = 'all_orders',
  PAST_ORDERS = 'past',
  PAID_RUNNING_ORDERS = 'paid_running_orders',
  UNPAID_RUNNING_ORDERS = 'unpaid_running_orders',
  SCHEDULED_ORDERS = 'schedule'
}

export enum DISCOUNT_MODAL {
  OPEN_USER_FORM = "open_user_form"
}

export enum KIOSK_ORDER_STATUS {
  UNPAID = 1,
  PAID = 2
}
